$(function(){
  
  console.log("%cACG scripts loaded", "color: green; font-size: 12px");
  
  // Quantity +/- controls (kept exactly as you had them)
  $(".salba-btn-quantity").on("click", function(e) {
    e.preventDefault();
    var $input   = $(this).parent().find('.salba-quantity');
    var $value   = Number($input.val());
    var $inStock = $input.attr("data-inventory-quantity");

    var $newValue = $(this).hasClass('plus') ? $value + 1 : $value - 1;
    if ($newValue < 0) $newValue = 0;
    if ($newValue > $inStock) $newValue = $inStock;

    $input.val($newValue);
  });
});

/* === SALBA popup sizing: widen/taller + drop ~50px (safe/minimal) === */
(function () {
  function salbaSizePopup() {
    var $wraps = $('.salba-popup-product-grid-wrapper');
    if (!$wraps.length) return;

    $wraps.each(function () {
      var $wrap = $(this);
      var $box  = $wrap.parent(); // the white modal container

      // Let inner wrapper grow and never clip horizontally
      $wrap.css({
        width: 'auto',
        'max-width': 'none',
        'overflow-x': 'visible'
      });

      if ($box && $box.length) {
        // Widen/taller modal, scroll inside, and drop ~50px from top
        $box.css({
          width: 'min(1280px, 98vw)',
          'max-width': 'none',
          'max-height': 'calc(100vh - 140px)',
          'overflow-y': 'auto',
          'overflow-x': 'visible',
          'margin-top': '50px',
          'margin-left': 'auto',
          'margin-right': 'auto',
          'z-index': 99999
        });
      }
    });
  }

  // Run after load, on clicks (when the popup usually opens), and on resize
  document.addEventListener('DOMContentLoaded', function(){ setTimeout(salbaSizePopup, 50); });
  document.addEventListener('click', function(){ setTimeout(salbaSizePopup, 100); });
  window.addEventListener('resize', function(){ setTimeout(salbaSizePopup, 100); });

  // Shopify editor / dynamic sections (safe if not present)
  document.addEventListener('shopify:section:load', salbaSizePopup);
  document.addEventListener('shopify:section:select', salbaSizePopup);
})();
